(function(){
  var root=document.getElementById('cfmd');if(!root)return;
  var DESDE='desde',HASTA='hasta';
  function fix(){
    root.querySelectorAll('.lin').forEach(function(lin){
      var nota=lin.querySelector('.lnota'),val=lin.querySelectorAll('.val')[1];
      if(!nota||!val)return;
      var max=nota.getAttribute('data-max');
      if(!max){
        var mm=(nota.textContent||'').match(/(\d+)\s*cm/);
        if(mm){max=mm[1];nota.setAttribute('data-max',max);}
      }
      var base=val.getAttribute('data-base');
      if(!base){base=(val.textContent||'').match(/(\d+)/)[1];val.setAttribute('data-base',base);}
      if(max){
        nota.classList.remove('fija');
        val.innerHTML=base+' cm<span class="pre">'+DESDE+'</span>';
        nota.innerHTML=max+' cm<span class="pre">'+HASTA+'</span>';
      }else{
        nota.classList.add('fija');
      }
    });
  }
  root.addEventListener('click',function(){setTimeout(fix,0)});
  var tries=0,iv=setInterval(function(){if(root.querySelector('.lnota')||++tries>40){clearInterval(iv);fix();}},50);
})();
